var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"page404"},[_c('div',{staticClass:"e404"}),_c('div',{staticClass:"error-tips"},[_c('p',[_vm._v("页面访问错误，请稍后访问...")]),_c('a',{staticClass:"blueLink f14",attrs:{"href":_vm.overviewLink}},[_vm._v("前往概览页 >")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }